module.exports = __webpack_public_path__ + "img/sunexpress.f877672b.png";